(() => {
  'use strict';

  const on = (selector, event, callback) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.addEventListener(event, callback);
    });
  };

  const toggleClassById = (id, className, force) => {
    const element = document.getElementById(id);
    if (element) element.classList.toggle(className, force);
  };

  let lastCartFocus = null;
  let lastWishlistFocus = null;

  const setOpenState = (id, open) => {
    const element = document.getElementById(id);
    if (!element) return null;

    element.classList.toggle('open', open);
    element.setAttribute('aria-hidden', open ? 'false' : 'true');
    return element;
  };

  const syncDrawerEnvironment = () => {
    const siteHeader = document.getElementById('site-header');
    const hasOpenHeaderDrawer = Boolean(
      document.querySelector('#cart-drawer.open, #wishlist-drawer.open')
    );

    siteHeader?.classList.toggle('has-open-drawer', hasOpenHeaderDrawer);
    document.querySelectorAll('[data-open-cart]').forEach((button) => {
      button.setAttribute('aria-expanded', document.getElementById('cart-drawer')?.classList.contains('open') ? 'true' : 'false');
    });

    const shouldLockPage = Boolean(
      document.querySelector(
        '#cart-drawer.open, #wishlist-drawer.open, .filters-desktop.open, .filter-drawer-overlay.open, .pdp-lightbox.open, .pdp-lightbox-overlay.open'
      )
    );

    document.documentElement.classList.toggle('drawer-scroll-locked', shouldLockPage);
    document.body?.classList.toggle('drawer-scroll-locked', shouldLockPage);
  };

  const focusDrawerCloseButton = (drawer, selector) => {
    if (!drawer) return;

    window.requestAnimationFrame(() => {
      const closeButton = drawer.querySelector(selector);
      if (closeButton instanceof HTMLElement) {
        closeButton.focus({ preventScroll: true });
      }
    });
  };

  const openCartDrawer = (trigger = document.activeElement) => {
    if (trigger instanceof HTMLElement) lastCartFocus = trigger;

    setOpenState('cart-drawer-overlay', true);
    const drawer = setOpenState('cart-drawer', true);
    syncDrawerEnvironment();
    focusDrawerCloseButton(drawer, '[data-close-cart]');
  };

  const closeCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    const wasOpen = drawer?.classList.contains('open');

    setOpenState('cart-drawer-overlay', false);
    setOpenState('cart-drawer', false);
    syncDrawerEnvironment();

    if (wasOpen && lastCartFocus?.isConnected) {
      window.requestAnimationFrame(() => lastCartFocus.focus({ preventScroll: true }));
    }
  };

  const openFilters = () => {
    document.querySelector('.filters-desktop')?.classList.add('open');
    document.querySelector('.filter-drawer-overlay')?.classList.add('open');
    syncDrawerEnvironment();
  };

  const closeFilters = () => {
    document.querySelector('.filters-desktop')?.classList.remove('open');
    document.querySelector('.filter-drawer-overlay')?.classList.remove('open');
    syncDrawerEnvironment();
  };

  const readWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem('vexx-wishlist') || '[]');
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    localStorage.setItem('vexx-wishlist', JSON.stringify(items));
    document.querySelectorAll('[data-wishlist-badge]').forEach((badge) => {
      badge.textContent = items.length;
      badge.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.some((item) => item.handle === button.dataset.productHandle);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (document.getElementById('wishlist-drawer')?.classList.contains('open')) {
      renderWishlistDrawer();
    }
  };

  const openWishlistDrawer = (trigger = document.activeElement) => {
    if (trigger instanceof HTMLElement) lastWishlistFocus = trigger;

    setOpenState('wishlist-drawer-overlay', true);
    const drawer = setOpenState('wishlist-drawer', true);
    syncDrawerEnvironment();
    renderWishlistDrawer();
    focusDrawerCloseButton(drawer, '[data-close-wishlist]');
  };

  const closeWishlistDrawer = () => {
    const drawer = document.getElementById('wishlist-drawer');
    const wasOpen = drawer?.classList.contains('open');

    setOpenState('wishlist-drawer-overlay', false);
    setOpenState('wishlist-drawer', false);
    syncDrawerEnvironment();

    if (wasOpen && lastWishlistFocus?.isConnected) {
      window.requestAnimationFrame(() => lastWishlistFocus.focus({ preventScroll: true }));
    }
  };

  const emptyWishlistHtml = () => document.getElementById('wishlist-empty-template')?.innerHTML || '';

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    const format = window.themeMoneyFormat || '${{amount}}';
    return format.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  };


  let cartCountdownTimer = null;

  const padCountdownNumber = (value) => String(Math.max(0, Number(value) || 0)).padStart(2, '0');

  const getCartCountdownEnd = (countdownElement) => {
    const sourceCountdown = document.querySelector(
      '[data-countdown-bar][data-countdown-end], .custom-countdown-bar[data-countdown-end]'
    );

    return sourceCountdown?.dataset.countdownEnd
      || countdownElement?.dataset.fallbackEnd
      || '';
  };

  const updateCartCountdown = () => {
    const countdown = document.querySelector('[data-cart-countdown]');
    if (!countdown) return;

    const endTime = Date.parse(getCartCountdownEnd(countdown));
    if (Number.isNaN(endTime)) {
      countdown.hidden = true;
      return;
    }

    countdown.hidden = false;
    const remaining = endTime - Date.now();
    const title = countdown.querySelector('[data-cart-countdown-title]');
    const units = countdown.querySelector('[data-cart-countdown-units]');

    if (remaining <= 0) {
      countdown.classList.add('is-expired');
      if (title) title.textContent = 'THE OFFER HAS ENDED';
      if (units) units.hidden = true;
      return;
    }

    countdown.classList.remove('is-expired');
    if (title) title.textContent = 'OFFER ENDS IN';
    if (units) units.hidden = false;

    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    Object.entries(values).forEach(([unit, value]) => {
      const output = countdown.querySelector(`[data-cart-countdown-${unit}]`);
      if (output) output.textContent = padCountdownNumber(value);
    });
  };

  const initCartCountdown = () => {
    if (cartCountdownTimer) {
      window.clearInterval(cartCountdownTimer);
      cartCountdownTimer = null;
    }

    if (!document.querySelector('[data-cart-countdown]')) return;

    updateCartCountdown();
    cartCountdownTimer = window.setInterval(updateCartCountdown, 1000);
  };

  const wishlistRowHtml = (product) => {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const variant = product.variants && product.variants[0];
    const price = variant ? formatMoney(variant.price) : '';
    return `
      <div class="wishlist-row" data-wishlist-row="${product.handle}">
        <a class="wishlist-row__thumb" href="/products/${product.handle}">
          ${image ? `<img src="${image}" alt="" loading="lazy">` : 'Photo'}
        </a>
        <a class="wishlist-row__info" href="/products/${product.handle}">
          <div class="wishlist-row__title">${product.title}</div>
          <div class="wishlist-row__price">${price}</div>
        </a>
        ${variant ? `<span class="quickadd-btn" data-wishlist-quickadd data-variant-id="${variant.id}" aria-label="Add ${product.title} to bag" role="button" tabindex="0">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
        </span>` : ''}
        <button type="button" class="wishlist-row__remove" data-wishlist-remove="${product.handle}" aria-label="Remove ${product.title}">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 4L20 20M20 4L4 20" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>
        </button>
      </div>`;
  };

  const renderWishlistDrawer = () => {
    const body = document.getElementById('wishlist-drawer-body');
    if (!body) return;
    const items = readWishlist();
    if (!items.length) {
      body.innerHTML = emptyWishlistHtml();
      return;
    }
    body.innerHTML = '<div class="wishlist-loading">Loading…</div>';
    Promise.all(
      items.map((item) =>
        fetch(`/products/${item.handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      const rows = products.filter(Boolean).map(wishlistRowHtml).join('');
      body.innerHTML = rows || emptyWishlistHtml();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    on('[data-open-menu]', 'click', () => toggleClassById('mobile-menu-overlay', 'open', true));
    on('[data-close-menu]', 'click', () => toggleClassById('mobile-menu-overlay', 'open', false));
    on('[data-toggle-search]', 'click', () => toggleClassById('nav-search-inline', 'open'));
    on('[data-open-mobile-search]', 'click', () => toggleClassById('nav-search-mobile', 'open', true));
    on('[data-close-mobile-search]', 'click', () => toggleClassById('nav-search-mobile', 'open', false));

    const urlParams = new URLSearchParams(window.location.search);
    let shouldOpenCart = urlParams.get('cart_open') === '1';
    try {
      shouldOpenCart = shouldOpenCart || sessionStorage.getItem('vexx-open-cart') === 'true';
      sessionStorage.removeItem('vexx-open-cart');
    } catch (error) {
      shouldOpenCart = shouldOpenCart;
    }

    if (shouldOpenCart) {
      if (urlParams.has('cart_open')) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('cart_open');
        window.history.replaceState({}, '', cleanUrl.toString());
      }
      openCartDrawer();
    }

    document.addEventListener('click', (event) => {
      const eventTarget = event.target instanceof Element ? event.target : null;
      if (!eventTarget) return;

      const continueShopping = eventTarget.closest('[data-continue-shopping]');
      if (continueShopping) {
        const isCartPage = /^\/cart\/?$/.test(window.location.pathname);
        if (!isCartPage) {
          event.preventDefault();
          closeCartDrawer();
        }
        return;
      }

      const closeCart = eventTarget.closest('[data-close-cart]');
      if (closeCart) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      const openCart = eventTarget.closest('[data-open-cart]');
      if (openCart) {
        event.preventDefault();
        openCartDrawer(openCart);
        return;
      }

      const closeWishlist = eventTarget.closest('[data-close-wishlist]');
      if (closeWishlist) {
        event.preventDefault();
        closeWishlistDrawer();
        return;
      }

      const openWishlist = eventTarget.closest('[data-open-wishlist]');
      if (openWishlist) {
        event.preventDefault();
        openWishlistDrawer(openWishlist);
      }
    });

    on('[data-open-filters]', 'click', openFilters);
    on('[data-close-filters]', 'click', closeFilters);
    on('[data-toggle-sort]', 'click', () => document.getElementById('sort-popover')?.classList.toggle('open'));
    writeWishlist(readWishlist());
    initCartCountdown();
    syncDrawerEnvironment();

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const handle = button.dataset.productHandle;
        if (!handle) return;
        const items = readWishlist();
        const index = items.findIndex((item) => item.handle === handle);
        if (index >= 0) {
          items.splice(index, 1);
        } else {
          items.push({
            handle,
            title: button.dataset.productTitle || handle,
            url: button.dataset.productUrl || window.location.pathname,
          });
        }
        writeWishlist(items);
      });

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        button.click();
      });
    });

    document.getElementById('wishlist-drawer-body')?.addEventListener('click', async (event) => {
      const removeButton = event.target.closest('[data-wishlist-remove]');
      if (removeButton) {
        const handle = removeButton.dataset.wishlistRemove;
        writeWishlist(readWishlist().filter((item) => item.handle !== handle));
        return;
      }

      const quickAddButton = event.target.closest('[data-wishlist-quickadd]');
      if (quickAddButton) {
        const id = quickAddButton.dataset.variantId;
        if (!id) return;
        quickAddButton.setAttribute('aria-busy', 'true');
        try {
          const body = new FormData();
          body.set('id', id);
          body.set('quantity', '1');
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          if (!response.ok) throw new Error('Quick add failed');
          const reloadUrl = new URL(window.location.href);
          reloadUrl.searchParams.set('cart_open', '1');
          window.location.href = reloadUrl.toString();
        } catch (error) {
          quickAddButton.removeAttribute('aria-busy');
        }
      }
    });

    document.querySelectorAll('[data-sort-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', button.dataset.sortValue);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('.product-card__quickadd').forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const card = button.closest('.product-card');
        const id = card?.dataset.quickVariantId;
        if (!id) return;

        button.setAttribute('aria-busy', 'true');
        try {
          const body = new FormData();
          body.set('id', id);
          body.set('quantity', '1');
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          if (!response.ok) throw new Error('Quick add failed');
          const reloadUrl = new URL(window.location.href);
          reloadUrl.searchParams.set('cart_open', '1');
          window.location.href = reloadUrl.toString();
        } catch (error) {
          window.location.href = card?.href || '/cart';
        }
      });

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        button.click();
      });
    });

    const handleize = (value) => String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const applyClientProductFilters = (params) => {
      const activeOptionFilters = [];
      params.forEach((value, key) => {
        if (!key.startsWith('filter.v.option.') || !value) return;
        activeOptionFilters.push({
          option: handleize(key.replace('filter.v.option.', '')),
          value: handleize(value),
        });
      });

      document.querySelectorAll('.product-grid .product-card').forEach((card) => {
        const matchesOptions = activeOptionFilters.every((filter) => {
          const values = ` ${card.getAttribute(`data-option-${filter.option}`) || ''} `;
          return values.includes(` ${filter.value} `);
        });
        card.hidden = !matchesOptions;
      });

      const emptyState = document.querySelector('[data-filter-empty]');
      if (emptyState) {
        const visibleCards = document.querySelectorAll('.product-grid .product-card:not([hidden])').length;
        emptyState.hidden = visibleCards > 0;
      }
    };

    const applyFilterState = () => {
      const params = new URLSearchParams(window.location.search);
      document.querySelectorAll('[data-filter-param][data-filter-value]').forEach((button) => {
        button.classList.toggle('active', params.get(button.dataset.filterParam) === button.dataset.filterValue);
      });
      applyClientProductFilters(params);

      const hasAnyFilter = Array.from(params.keys()).some((key) => key.startsWith('filter.'));
      const nativeActiveFilters = document.querySelector('.filter-group--active');
      const clearAll = document.querySelector('[data-clear-all-filters]');
      if (clearAll) clearAll.hidden = !hasAnyFilter || !!nativeActiveFilters;
    };

    document.querySelectorAll('[data-filter-param][data-filter-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const url = new URL(window.location.href);
        const param = button.dataset.filterParam;
        const value = button.dataset.filterValue;

        if (url.searchParams.get(param) === value) {
          url.searchParams.delete(param);
        } else {
          url.searchParams.set(param, value);
        }

        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('[data-filter-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const url = new URL(window.location.href);
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() === '') {
            url.searchParams.delete(key);
          } else {
            url.searchParams.set(key, value);
          }
        });
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    applyFilterState();

    on('[data-carousel-prev]', 'click', (event) => {
      const carousel = document.getElementById(event.currentTarget.dataset.carouselPrev);
      if (carousel) carousel.scrollBy({ left: -carousel.clientWidth * 0.8, behavior: 'smooth' });
    });

    on('[data-carousel-next]', 'click', (event) => {
      const carousel = document.getElementById(event.currentTarget.dataset.carouselNext);
      if (carousel) carousel.scrollBy({ left: carousel.clientWidth * 0.8, behavior: 'smooth' });
    });

    document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      const carouselId = slider.dataset.heroSlider;
      const track = document.getElementById(carouselId);
      if (!track) return;

      const slides = Array.from(track.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
      if (slides.length < 2) return;

      let activeIndex = 0;
      let autoplayTimer = null;

      const goToSlide = (index) => {
        const clamped = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
      };

      const setActive = (index) => {
        activeIndex = index;
        dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
      };

      const stopAutoplay = () => {
        if (autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        if (slider.dataset.heroAutoplay !== 'true') return;
        stopAutoplay();
        const seconds = Number(slider.dataset.heroAutoplaySpeed) || 6;
        autoplayTimer = setInterval(() => {
          goToSlide(activeIndex + 1);
        }, seconds * 1000);
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            setActive(slides.indexOf(entry.target));
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach((slide) => observer.observe(slide));

      slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => {
        goToSlide(activeIndex - 1);
        startAutoplay();
      });
      slider.querySelector('[data-hero-next]')?.addEventListener('click', () => {
        goToSlide(activeIndex + 1);
        startAutoplay();
      });
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
          startAutoplay();
        });
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });

    on('[data-qty-minus]', 'click', (event) => {
      const wrapper = event.currentTarget.closest('[data-qty-wrapper]');
      const input = wrapper?.querySelector('input');
      if (!input) return;
      const minimum = Number.isFinite(Number(input.min)) ? Number(input.min) : 0;
      input.value = Math.max(minimum, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (wrapper?.hasAttribute('data-submit-on-qty-change')) input.form?.submit();
    });

    on('[data-qty-plus]', 'click', (event) => {
      const wrapper = event.currentTarget.closest('[data-qty-wrapper]');
      const input = wrapper?.querySelector('input');
      if (!input) return;
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (wrapper?.hasAttribute('data-submit-on-qty-change')) input.form?.submit();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeCartDrawer();
      closeWishlistDrawer();
      closeFilters();
      closePdpLightbox();
      document.getElementById('sort-popover')?.classList.remove('open');
    });

    const initProductOptions = (form) => {
      const info = form.closest('.pdp-info');
      const variantsScript = info?.querySelector('[data-product-variants]');
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      if (!variants.length) return;

      const idInput = form.querySelector('[name="id"]');
      const addButton = form.querySelector('[type="submit"]');
      const price = info?.querySelector('.pdp-price');
      const priceCompare = info?.querySelector('[data-pdp-price-compare]');
      const saveNote = info?.querySelector('[data-pdp-save-note]');
      const lowStockNote = info?.querySelector('[data-pdp-low-stock]');
      const soldOutBadge = document.querySelector('[data-pdp-soldout-badge]');
      const discountBadge = document.querySelector('[data-pdp-discount-badge]');
      const staticTagBadge = document.querySelector('[data-pdp-static-tag]');
      const mediaWrap = document.querySelector('[data-pdp-media-wrap]');
      const mediaImage = document.querySelector('.pdp-gallery__main img');
      const defaultButtonText = addButton?.textContent.trim() || 'ADD TO BAG';

      const selectedOptions = () => {
        const optionCount = Math.max(...variants.map((variant) => variant.options.length));
        return Array.from({ length: optionCount }, (_, index) => {
          const active = form.querySelector(`[data-product-option][data-option-position="${index + 1}"].active`);
          return active?.dataset.optionValue || '';
        });
      };

      const findVariant = () => {
        const selected = selectedOptions();
        return variants.find((variant) => variant.options.every((option, index) => option === selected[index]));
      };

      const updateVariant = () => {
        const variant = findVariant();
        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'UNAVAILABLE';
          }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (price && variant.price) price.textContent = variant.price;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? defaultButtonText : 'SOLD OUT';
        }
        if (mediaImage && variant.image) {
          mediaImage.removeAttribute('srcset');
          mediaImage.removeAttribute('sizes');
          mediaImage.src = variant.image;
          if (mediaWrap && variant.imageLarge) mediaWrap.dataset.largeUrl = variant.imageLarge;
          document.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
            thumb.classList.toggle('active', thumb.dataset.imageUrl === variant.image);
          });
        }

        const isOnSale = variant.available && Number(variant.compareAtPriceAmount) > Number(variant.priceAmount);
        const isSoldOut = !variant.available;

        if (price) price.classList.toggle('pdp-price--sale', isOnSale);
        if (priceCompare) {
          priceCompare.hidden = !isOnSale;
          if (isOnSale) priceCompare.textContent = variant.compareAtPrice;
        }
        if (saveNote) {
          saveNote.hidden = !isOnSale;
          if (isOnSale) {
            saveNote.textContent = `Save ${formatMoney(Number(variant.compareAtPriceAmount) - Number(variant.priceAmount))}`;
          }
        }
        if (discountBadge) {
          discountBadge.hidden = !isOnSale;
          if (isOnSale) {
            const percent = Math.round(((Number(variant.compareAtPriceAmount) - Number(variant.priceAmount)) / Number(variant.compareAtPriceAmount)) * 100);
            discountBadge.textContent = `-${percent}%`;
          }
        }
        if (soldOutBadge) soldOutBadge.hidden = !isSoldOut;
        if (staticTagBadge) staticTagBadge.hidden = isSoldOut;
        if (mediaWrap) mediaWrap.classList.toggle('pdp-gallery__main--soldout', isSoldOut);

        const showLowStock = variant.available
          && variant.inventoryManagement === 'shopify'
          && variant.inventoryPolicy === 'deny'
          && Number(variant.inventoryQuantity) > 0
          && Number(variant.inventoryQuantity) <= 5;
        if (lowStockNote) {
          lowStockNote.hidden = !showLowStock;
          if (showLowStock) lowStockNote.textContent = `Only ${variant.inventoryQuantity} left`;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };

      form.querySelectorAll('[data-product-option]').forEach((button) => {
        button.addEventListener('click', () => {
          form.querySelectorAll(`[data-product-option][data-option-position="${button.dataset.optionPosition}"]`).forEach((peer) => {
            peer.classList.toggle('active', peer === button);
          });
          updateVariant();
        });
      });

      updateVariant();
    };

    document.querySelectorAll('[data-pdp-thumbs]').forEach((rail) => {
      const mediaImage = document.querySelector('.pdp-gallery__main img');
      const mediaWrap = document.querySelector('[data-pdp-media-wrap]');
      rail.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const url = thumb.dataset.imageUrl;
          if (mediaImage && url) {
            mediaImage.removeAttribute('srcset');
            mediaImage.removeAttribute('sizes');
            mediaImage.src = url;
          }
          if (mediaWrap && thumb.dataset.imageUrlLarge) mediaWrap.dataset.largeUrl = thumb.dataset.imageUrlLarge;
          rail.querySelectorAll('[data-pdp-thumb]').forEach((t) => t.classList.toggle('active', t === thumb));
        });
      });
    });

    const pdpLightbox = document.getElementById('pdp-lightbox');
    const pdpLightboxOverlay = document.querySelector('.pdp-lightbox-overlay');
    const pdpLightboxImg = document.getElementById('pdp-lightbox-img');

    const openPdpLightbox = () => {
      const mediaWrap = document.querySelector('[data-pdp-media-wrap]');
      const mediaImage = document.querySelector('.pdp-gallery__main img');
      if (!pdpLightbox || !pdpLightboxImg || !mediaImage) return;
      pdpLightboxImg.src = mediaWrap?.dataset.largeUrl || mediaImage.src;
      pdpLightbox.classList.add('open');
      pdpLightboxOverlay?.classList.add('open');
      syncDrawerEnvironment();
    };

    const closePdpLightbox = () => {
      if (!pdpLightbox) return;
      pdpLightbox.classList.remove('open');
      pdpLightboxOverlay?.classList.remove('open');
      syncDrawerEnvironment();
    };

    on('[data-pdp-open-lightbox]', 'click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openPdpLightbox();
    });

    document.querySelector('.pdp-gallery__main')?.addEventListener('click', (event) => {
      if (event.target.closest('.pdp-wish') || event.target.closest('[data-pdp-open-lightbox]')) return;
      openPdpLightbox();
    });

    on('[data-close-lightbox]', 'click', closePdpLightbox);

    document.querySelectorAll('.pdp-form').forEach((form) => {
      initProductOptions(form);

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const originalText = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'ADDING...';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });

          if (!response.ok) throw new Error('Cart add failed');
          const reloadUrl = new URL(window.location.href);
          reloadUrl.searchParams.set('cart_open', '1');
          window.location.href = reloadUrl.toString();
        } catch (error) {
          if (button) {
            button.disabled = false;
            button.textContent = originalText;
          }
          window.location.href = '/cart';
        }
      });
    });
  });

  document.addEventListener('shopify:section:load', () => {
    toggleClassById('mobile-menu-overlay', 'open', false);
    toggleClassById('nav-search-mobile', 'open', false);
    initCartCountdown();
    syncDrawerEnvironment();
  });
})();
